import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { getBikeColors } from "../model/bikeColors";
export default function BikeColor({ value, showLabel = true, compact = false }) {
  const colors = getBikeColors(value);
  const label = String(value || "").trim() || "Sin información";
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.75,
        minWidth: 0,
        maxWidth: "100%",
      }}
    >
      <Box
        component="span"
        role="img"
        aria-label={`Color de bicicleta: ${label}`}
        sx={{ display: "inline-flex", gap: 0.4, flexShrink: 0 }}
      >
        {(colors.length ? colors : [null]).map((color, index) => (
          <Box
            component="span"
            key={`${color}-${index}`}
            sx={{
              display: "block",
              width: compact ? 12 : 16,
              height: compact ? 12 : 16,
              borderRadius: "50%",
              bgcolor: color || "#f1f5f9",
              border: "1px solid #526579",
              boxShadow: "inset 0 0 0 1px #ffffff30",
            }}
          />
        ))}
      </Box>
      {showLabel && (
        <Typography
          component="span"
          sx={{
            fontSize: compact ? "0.7rem" : "0.8rem",
            color: "#334155",
            lineHeight: 1.4,
            overflowWrap: "anywhere",
          }}
        >
          {label}
        </Typography>
      )}
    </Box>
  );
}
BikeColor.propTypes = {
  value: PropTypes.string,
  showLabel: PropTypes.bool,
  compact: PropTypes.bool,
};
